// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 270) return "static/chunks/270-3875c2edbd214345.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"542":"3bfd4ce666cee725","571":"a85fbd28155bc806"}[chunkId] + ".js";
};